import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Drawer, useMediaQuery } from '@mui/material';

// project imports
import MenuList from './MenuList';
import LogoSection from '../LogoSection';
import DropDown from 'ui-component/atoms/DropDown';
// import MenuCard from './MenuCard';
import { drawerWidth } from 'store/constant';

import { SET_SELECTED_TYPE } from 'store/actions';

// ==============================|| SIDEBAR DRAWER ||============================== //

const Sidebar = ({ drawerOpen, drawerToggle, window, dropDown }) => {
    const theme = useTheme();
    const params = useParams();
    const navigate = useNavigate();
    const userData = useSelector((state) => state.user);
    const [navigationData, setNavigationData] = useState({});
    const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));
    const { client } = params;
    const dispatch = useDispatch();
    const handleChange = (e) => {
        const selectedClient = e.target.value;
        if (selectedClient !== client) {
            navigate(`/${selectedClient}`);
            dispatch({ type: SET_SELECTED_TYPE, payload: selectedClient });
        }
    };

    const loadNavigationData = () => {
        const { clients } = userData;
        // eslint-disable-next-line camelcase
        const { j_json = {} } = clients[client].details;
        // #todo use _get
        // eslint-disable-next-line camelcase
        setNavigationData(j_json.navigation);
    };

    useEffect(() => {
        if (client) {
            // eslint-disable-next-line no-debugger
            // debugger;
            loadNavigationData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [client, userData]);

    const dropDownComponent =
        dropDown && dropDown.list ? <DropDown list={dropDown.list} label="Clients" selectedValue={client} onChange={handleChange} /> : null;
    const drawer = (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%'
            }}
        >
            <Box sx={{ flexShrink: 0, display: 'flex', px: '16px', py: '12px', background: '#FAFAFA' }}>
                <LogoSection />
            </Box>
            <Box className="clientsSelect" sx={{ flexShrink: 0 }}>
                <h6>Client</h6>
                {dropDownComponent}
            </Box>
            <MenuList navigationData={navigationData} drawerToggle={drawerToggle} />
        </Box>
    );

    const container = window !== undefined ? () => window.document.body : undefined;

    return (
        <Box component="nav" sx={{ flexShrink: { md: 0 }, width: matchUpMd ? drawerWidth : 'auto' }} aria-label="Main navigation">
            <Drawer
                key={`drawer-${drawerOpen}`}
                container={container}
                variant={matchUpMd ? 'persistent' : 'temporary'}
                anchor="left"
                open={drawerOpen}
                onClose={drawerToggle}
                data-drawer-open={drawerOpen}
                sx={{
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        background: theme.palette.background.default,
                        color: theme.palette.text.primary,
                        borderRight: 'none',
                        overflow: 'hidden',
                        top: 0,
                        [theme.breakpoints.down('md')]: {
                            top: '56px',
                            height: 'calc(100% - 56px)'
                        }
                    },
                    // Force override Material-UI's inline styles on mobile when open
                    ...(!matchUpMd &&
                        drawerOpen && {
                            '& .MuiDrawer-paper': {
                                visibility: 'visible !important',
                                transform: 'translateX(0) !important',
                                // Override any inline styles
                                '&[style*="visibility"]': {
                                    visibility: 'visible !important'
                                },
                                '&[style*="transform"]': {
                                    transform: 'translateX(0) !important'
                                }
                            }
                        })
                }}
                ModalProps={{
                    keepMounted: true,
                    disableAutoFocus: true,
                    disableEnforceFocus: true,
                    disableRestoreFocus: true
                }}
                BackdropProps={{
                    invisible: false
                }}
                color="inherit"
            >
                {drawer}
            </Drawer>
        </Box>
    );
};

Sidebar.propTypes = {
    drawerOpen: PropTypes.bool,
    drawerToggle: PropTypes.func,
    window: PropTypes.object
};
Sidebar.defaultProps = {};

export default Sidebar;
